import axios from 'axios'

/**
 * @description service to login in bluesite
 * @param email
 * @param password
 */
const login = async (email: string, password: string) => {
  const apiUrl = `${process.env.REACT_APP_MAIN_API}/auth/login`
  const config = {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  const payload: { email: string; password: string } = {
    email,
    password,
  }

  const response = await axios.post(apiUrl, payload, config)

  return response
}

export default login
